import { newE2EPage } from "@stencil/core/testing";
import { testValidHtml } from "../../../test-utils/html-validate";

describe("checkbox-tile", () => {
    it("should match to snapshot", async () => {
        const page = await newE2EPage();
        await page.setContent(
            `<ux-checkbox-tile checked name="name-attr" tag="tag string" value="testvalue" img-src="#">
                <div slot="description">Title of the description</div>
            </ux-checkbox-tile>`
        );
        const el = await page.find("ux-checkbox-tile");
        await page.waitForChanges();
        expect(el).toMatchSnapshot();
    });

    it("should render valid html", async () => {
        await testValidHtml(`<ux-checkbox-tile checked name="name-attr" tag="tag string" value="testvalue" img-src="#">
            <div slot="description">Title of the description</div>
        </ux-checkbox-tile>`);
    });
});
